<template>
  <div id="app">
    <div v-if="isShow">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      isShow: true,
    }
  },
  computed: {
    key() {
      return this.$route.name
        ? this.$route.name + new Date()
        : this.$route + new Date()
    },
  },
  watch: {
    key() {
      if (localStorage.getItem('isReach') == 1) {
        this.isShow = false
        this.$nextTick(() => {
          this.isShow = true
          localStorage.setItem('isReach', 0)
        })
      }
    },
  },
}
</script>

<style lang="scss">
@import '//at.alicdn.com/t/font_1193048_6kixl16y8bc.css';
@import '@/common/common.css';

.van-share-sheet__cancel {
  color: #999 !important;
}
.share_box .van-share-sheet__options {
  padding: 16px 0;
  display: flex;
  justify-content: space-around;
}
html {
  font-size: 24px;
}

.fz24 {
  font-size: 24px;
}
.fz30 {
  font-size: 30px !important;
}
.fwt {
  font-weight: 600;
}
.menu_box .van-tabs__line {
  height: 17px;
  background-color: #000;
  background: url(https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/siyutuoke_img/icon_home01.png)
    no-repeat center center;
  background-size: 40px 17px;
}
.menu_box .van-tabs__nav--line.van-tabs__nav--complete {
  padding-left: 0 !important;
}
.menu_box .van-tab:first-child {
  background: url(https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/siyutuoke_img/sy_n_icon_huo.png)
    no-repeat 100% 20%;
  background-size: 8 11px;
}
.van-list__finished-text {
  font-size: 22px !important;
}
.footer_height .van-goods-action {
  height: 210px !important;
  background: #fff !important;
}
.van-dialog__message--has-title {
  padding-top: 50px !important;
}
/* .van_swipe_box .van-swipe__track{
  width: 482px !important;
  height: 260px !important;
} */

.course .van-cell.van-collapse-item__title{
		padding-left: 40px;
		background: url('https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/siyutuoke_img/c_catalogue.png') 0 center no-repeat;
		background-size: 30px 30px;
		/* border-bottom: .8px solid rgba(0,0,0,.1); */
	}
	
	/* 课程分佣 */
	.user_profit{
		width: 690px;
		background: #FFFFFF;
		box-shadow: 0px 0px 12px 2px rgba(0, 0, 0, 0.04);
		border-radius: 20px;
		margin: 14px auto 34px;
	}
	.user_profit .top_box{
		padding: 30px;
		border-bottom: 1px solid rgba(0,0,0,.04);
		span{
			color: #969799;
			font-size: 24px;
			height: 24px;
			line-height: 24px;
			display: block;
			margin-bottom: 24px;
		}
		p{
			color: #333333;
			font-size: 38px;
			font-weight: 500;
			height: 38px;
			line-height: 38px;
		}
		b{
			position: absolute;
			right: 30px;
			top: 37px;
			width: 136px;
			height: 66px;
			line-height: 66px;
			background: #EA443E;
			border-radius: 200px;
			text-align: center;
			color: #FFF;
			font-size: 26px;
		}
	}
	.foot{
		height: 84px;
		line-height: 84px;
		color: #969799;
		font-size: 24px;
		padding-left: 30px;
		strong{
			color: #333333;
			font-size: 29px;
			margin: 0 16px 0 9px;
			vertical-align: middle;
		}
		span{
			display: inline-block;
			width: 80px;
			height: 36px;
			line-height: 36px;
			background: #FFEFF1;
			border-radius: 20px;
			color: #EE0A24;
			font-size: 24px;
			text-align: center;
			vertical-align: middle;
		}
	}
	
	
</style>
